// extracted by mini-css-extract-plugin
export var boxItems = "_7q-1";
export var boxItemsLg = "_7q-2";
export var button = "_7q-7";
export var buttonHoverless = "_7q-9";
export var buttonLg = "_7q-8";
export var filterGroupBox = "_7q-0";
export var icon = "_7q-3";
export var iconSecondary = "_7q-6";
export var iconWrapper = "_7q-4";
export var iconWrapperLg = "_7q-5";
export var truncatedLabel = "_7q-a";